import React, { Component } from 'react';
import * as moment from 'moment';
import PropTypes from 'prop-types';
import FilmCard from './film-card';
import ScreenSwitcher from './switcher';
import loadScreen from './api';

export default class SchemeScreen extends Component {
  static propTypes = {
    isAdmin: PropTypes.bool,
    currentScreen: PropTypes.number,
  };

  static defaultProps = {
    isAdmin: false,
    currentScreen: 1,
  };

  constructor(props) {
    super(props);

    this.state = {
      isAdmin: props.isAdmin,
      serverTime: null,
      currentTime: null,
      lastUpdateTime: 0,
      data: null,
      screensCount: null,
      currentScreen: props.currentScreen,
      loading: true,
    };

    this.timeDifference = null;
  }

  componentDidMount() {
    this.timeDifference = setInterval(this.tickTimer, 1000);

    this.loadData(this.state.currentScreen);
  }

  componentDidUpdate() {
    const { lastUpdateTime, currentScreen } = this.state;

    /* Если прошло 30 минут - шлём новый запрос */
    if (Math.floor(lastUpdateTime / 60) === 30) {
      this.loadData(currentScreen);
      this.setState({ lastUpdateTime: 0 });
    }
  }

  componentWillUnmount() {
    clearInterval(this.timeDifference);
  }

  loadData = screen => {
    loadScreen(screen).then(
      ({ data, serverTime, currentTime, screensCount }) => {
        this.setState({
          loading: false,
          serverTime,
          currentTime,
          screensCount,
          data,
        });
      },
    );
  };

  setScreen = screen => {
    if (screen !== this.state.currentScreen) {
      this.setState({ loading: true, currentScreen: screen });
      this.loadData(screen);
    }
  };

  /* Начинаем считать минуты с последнего апдейта и обновляем время с сервера в переменную currentTime */
  tickTimer = () => {
    this.setState(({ lastUpdateTime, currentTime }) => ({
      lastUpdateTime: lastUpdateTime + 1,
      currentTime: currentTime + 1,
    }));
  };

  getLastUpdateTime = () => {
    moment.locale('ru');
    return moment(this.state.serverTime).format('HH:mm');
  };

  /* Вывод карточки фильма */
  renderFilmCards = (films = []) => {
    const { serverTime, currentTime } = this.state;

    return films.map(film => (
      <FilmCard
        key={film.name}
        serverTime={serverTime}
        currentTime={currentTime}
        {...film}
      />
    ));
  };

  render() {
    const { data, currentScreen, isAdmin, screensCount, loading } = this.state;

    return (
      <div className="scheme-screen">
        {isAdmin && (
          <ScreenSwitcher
            currentScreen={currentScreen}
            screensCount={screensCount}
            setScreen={this.setScreen}
          />
        )}
        <div className="scheme-screen__content">
          {loading ? (
            <p className="scheme-screen__loader">Загрузка...</p>
          ) : (
            <>
              <div className="film-cards">{this.renderFilmCards(data)}</div>
              <p className="scheme-screen__timer">
                Информация обновлена в {this.getLastUpdateTime()}
              </p>
            </>
          )}
        </div>
      </div>
    );
  }
}
